import React from "react";
import styles from "./../styles.module.scss";
import { FallIcon } from "../../../Styles/Icons/DesignSystem";
import { AttendingIcon } from "../../../Styles/Icons/DesignSystem";
import CircleNotificationsIcon from "../../../Styles/Icons/DesignSystem/CircleNotificationsIcon";
import classNames from "classnames";

const FallStatusBanner = ({
  attending,
  detected,
  checkRequired,
  check2Required,
  staffMemberAttended,
  fallLocation,
  recentFall,
  fallTime,
}) => {
  const bannerIcon = () => {
    if (checkRequired || check2Required) {
      return <CircleNotificationsIcon />;
    }

    if (attending) {
      return <AttendingIcon />;
    }

    if (detected || (recentFall && !checkRequired && !check2Required)) {
      return <FallIcon />;
    }
  };

  const bannerText = () => {
    if (detected) {
      return `Fall detected: ${fallLocation}`;
    }

    if (attending) {
      return staffMemberAttended
        ? `${staffMemberAttended.forenames || ""} attending fall`
        : "Attending fall";
    }

    if (checkRequired && !check2Required) {
      return "To do: 30 min post-fall check";
    }

    if (check2Required) {
      return "To do: 2nd post-fall check";
    }

    if (recentFall) {
      return `Recent fall: ${fallTime}`;
    }
  };
  return (
    <div
      className={classNames(styles.fall_status_banner, {
        [styles.banner_detected]: detected,
        [styles.banner_acknowledged]:
          attending || checkRequired || check2Required,
        [styles.banner_recent_fall]:
          recentFall &&
          !detected &&
          !attending &&
          !check2Required &&
          !checkRequired,
      })}
    >
      <div className={styles.banner_icon}>{bannerIcon()}</div>
      <p className={styles.banner_text}>{bannerText()}</p>
    </div>
  );
};

export default FallStatusBanner;
